import getEncodedVerifierKey from './getEncodedVerifierKey'
export const getVerifierState = ({ client_id, storage }) => {
  const key = getEncodedVerifierKey(client_id);
  const value = JSON.parse(storage.getItem(key));
  return value;
}
